import eventBus from '../utils/eventBus';

const steps = () => {
  const quizzes = document.querySelectorAll('[data-wp-quiz]');
  quizzes.forEach(quiz => {

    const pages = quiz.querySelectorAll('.wp-quiz-item');

    // declaring the active fieldset & the total fieldset count

    let currentStep = 0;

    // change max step length here (default 4)
    const progressLength = 3;

    pages[currentStep].classList.add('wp-quiz-item--visible');

    // creates and stores a number of bullets

    let stepper = '<div class="wp-quiz-stepper__item wp-quiz-stepper__item--current wp-quiz-stepper__item--visible wp-quiz-stepper__item--visible--first"><span class="wp-quiz-stepper__item-value"><span class="wp-quiz-stepper__item-value-number">1</span><svg class="wp-quiz-stepper__item-value-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 15"><path d="m18.111 1.746-10.96 10.96-6.01-6.01" stroke="#fff" stroke-width="3"/></svg></span></div>';
    const stepperLength = pages.length - 1;
    for (let i = 1; i < stepperLength; ++i) {
      stepper +=  '<div class="wp-quiz-stepper__item'+ ((i + 1) <= progressLength - 1 ? ' wp-quiz-stepper__item--visible' : '') +''+ ((i + 1 ) === stepperLength ? ' wp-quiz-stepper__item--visible wp-quiz-stepper__item--visible--last' : '') +''+ ((i + 2 ) === stepperLength ? ' wp-quiz-stepper__item--second--last' : '') +'"><span class="wp-quiz-stepper__item-value"><span class="wp-quiz-stepper__item-value-number">'+(i + 1)+'</span><svg class="wp-quiz-stepper__item-value-icon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 15"><path d="m18.111 1.746-10.96 10.96-6.01-6.01" stroke="#fff" stroke-width="3"/></svg></span> </div>';
    }

    // injects bullets
    const stepperWrapperWrap = quiz.querySelector('.wp-quiz-stepper-wrap');
    const stepperWrapper = quiz.querySelector('.wp-quiz-stepper');
    stepperWrapper.innerHTML = stepperWrapper.innerHTML + stepper;
    stepperWrapper.style.setProperty('--progress-length', progressLength);
    const stepperItems = quiz.querySelectorAll('.wp-quiz-stepper__item');

    const prevButton = quiz.querySelector('[data-wp-quiz-back]');
    if(prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();

        let validate = true;

        if(currentStep === 0) {
          validate = false;
        }

        if(validate) {

          prevButton.classList.remove('is-hidden');

          pages[currentStep].classList.remove('wp-quiz-item--visible');
          stepperItems[currentStep].classList.remove('wp-quiz-stepper__item--current')
          stepperItems[currentStep].classList.remove('wp-quiz-stepper__item--checked')


          currentStep = currentStep - 1;

          stepperItems[currentStep].classList.add('wp-quiz-stepper__item--current')
          stepperItems[currentStep].classList.remove('wp-quiz-stepper__item--checked')

          if(pages[currentStep].classList.contains('wp-quiz-item--info-image') && !pages[currentStep].querySelector('.wp-quiz-slider')) {
          } else {
            pages[currentStep].classList.add('wp-quiz-item--is-pristine');
            pages[currentStep].classList.remove('wp-quiz-item--is-right');
          }

          [].forEach.call(stepperItems, function(el) {
            if(!el.classList.contains('wp-quiz-stepper__item--visible--last') && !el.classList.contains('wp-quiz-stepper__item--visible--first')) {
              el.classList.remove('wp-quiz-stepper__item--visible');
            }
          });

          pages[currentStep].classList.add('wp-quiz-item--visible');

          if(stepperItems[currentStep]) {
            stepperItems[currentStep].classList.add('wp-quiz-stepper__item--current')
            //stepperWrapper.style.setProperty('--progress-step', currentStep);

            if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--last')) {
              stepperItems[currentStep - 1].classList.add('wp-quiz-stepper__item--visible')
              stepperItems[currentStep - 2].classList.add('wp-quiz-stepper__item--visible')

              stepperWrapper.style.setProperty('--progress-step', progressLength);

            } else if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--first')) {
              stepperItems[currentStep + 1].classList.add('wp-quiz-stepper__item--visible')

              if(progressLength > 3) {
                stepperItems[currentStep + 2].classList.add('wp-quiz-stepper__item--visible')
              }

              prevButton.classList.add('is-hidden');
              stepperWrapper.style.setProperty('--progress-step', 0);

            } else {
              stepperItems[currentStep].classList.add('wp-quiz-stepper__item--visible')

              if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--last')) {
                stepperItems[currentStep - 1].classList.add('wp-quiz-stepper__item--visible')
                stepperWrapper.style.setProperty('--progress-step', 2);
              } else {

                if(progressLength > 3) {
                  stepperItems[currentStep + 1].classList.add('wp-quiz-stepper__item--visible')
                }
                stepperWrapper.style.setProperty('--progress-step', 1);
              }
            }
          }


          if(pages[currentStep].classList.contains('wp-quiz-item--final-screen')) {
            stepperWrapper.style.display = 'none';
          } else {
            stepperWrapper.style.display = '';
          }

          eventBus.emit('wp-quiz-step-changed', currentStep)
        }

      })
    }

    const nextBtns = quiz.querySelectorAll('[data-wp-quiz-next]');
    nextBtns.forEach(btn => {
      btn.addEventListener('click', () => {

        let validate = true;

        if(currentStep === pages.length) {
          validate = false;
        }

        if(validate) {
          pages[currentStep].classList.remove('wp-quiz-item--visible');
          stepperItems[currentStep].classList.remove('wp-quiz-stepper__item--current')
          stepperItems[currentStep].classList.add('wp-quiz-stepper__item--checked')

          prevButton.classList.remove('is-hidden');


          currentStep = currentStep + 1;
          pages[currentStep].classList.add('wp-quiz-item--visible');

          [].forEach.call(stepperItems, function(el) {
            if(!el.classList.contains('wp-quiz-stepper__item--visible--last') && !el.classList.contains('wp-quiz-stepper__item--visible--first')) {
              el.classList.remove('wp-quiz-stepper__item--visible');
            }
          });

          if(stepperItems[currentStep]) {
            stepperItems[currentStep].classList.add('wp-quiz-stepper__item--current')
            //stepperWrapper.style.setProperty('--progress-step', currentStep);

            if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--last')) {
              stepperItems[currentStep - 1].classList.add('wp-quiz-stepper__item--visible')
              stepperItems[currentStep - 2].classList.add('wp-quiz-stepper__item--visible')

              stepperWrapper.style.setProperty('--progress-step', progressLength);

            } else if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--first')) {
              if(progressLength > 3) {
                stepperItems[currentStep + 1].classList.add('wp-quiz-stepper__item--visible')
              }

              stepperWrapper.style.setProperty('--progress-step', 0);

            } else {
              stepperItems[currentStep].classList.add('wp-quiz-stepper__item--visible')

              if(stepperItems[currentStep].classList.contains('wp-quiz-stepper__item--visible--last')) {
                stepperItems[currentStep - 1].classList.add('wp-quiz-stepper__item--visible')
                stepperWrapper.style.setProperty('--progress-step', 2);
              } else {
                if(progressLength > 3) {
                  stepperItems[currentStep + 1].classList.add('wp-quiz-stepper__item--visible')
                }
                stepperWrapper.style.setProperty('--progress-step', 1);
              }
            }
          }


          if(pages[currentStep].classList.contains('wp-quiz-item--final-screen')) {
            stepperWrapperWrap.style.display = 'none';
          } else {
            stepperWrapperWrap.style.display = '';
          }

          eventBus.emit('wp-quiz-step-changed', currentStep)
        }

      });
    });

    const retryBtns = quiz.querySelectorAll('[data-wp-quiz-retry]');
    retryBtns.forEach(btn => {
      btn.addEventListener('click', () => {

        pages[currentStep].classList.add('wp-quiz-item--is-pristine');
        pages[currentStep].classList.remove('wp-quiz-item--is-wrong');
        pages[currentStep].classList.remove('wp-quiz-item--is-right');

      });
    });

    const resultOverlays = quiz.querySelectorAll('[data-wp-quiz-answer]');
    resultOverlays.forEach(resultOverlay => {
      resultOverlay.addEventListener('click', () => {

        if(pages[currentStep].classList.contains('wp-quiz-item--is-wrong')) {
          pages[currentStep].classList.remove('wp-quiz-item--is-wrong');
          pages[currentStep].classList.add('wp-quiz-item--is-pristine');
        }

      });
    });

  });
};

window.addEventListener('DOMContentLoaded', steps, { once: true });
